<template>
  <div>
    <div v-if="emails && emails.length > 0">
      <div class="bg-neutral-100 mx-auto border rounded-sm w-full max-w-[600px] text-black text-base select-none">
        <div class="px-6 py-4 border-b-2 w-full">
          <p><b>{{ t('comps.action_message_examples.to') }}:</b> {{ t('comps.action_message_examples.email') }}</p>
        </div>
        <div class="px-6 py-4 border-b-2 w-full">
          <p><b>{{ t('comps.action_message_examples.subject') }}:</b> {{ emails[current_item]?.subject }}</p>
        </div>
        <div class="px-6 py-4">
          {{ emails[current_item]?.body }}
        </div>
      </div>
      <div class="flex justify-center gap-8 mt-4">
        <UButton
          :disabled="current_item <= 1"
          color="neutral"
          variant="subtle"
          size="xl"
          icon="i-lucide-move-left"
          aria-label="Last"
          :class="{ 'opacity-60': current_item <= 1 }"
          @click="current_item--"
        />
        <UButton
          :disabled="current_item >= emails.length - 1"
          :class="{ 'opacity-60': current_item >= emails.length - 1 }"
          color="neutral"
          variant="subtle"
          size="xl"
          aria-label="Next"
          icon="i-lucide-move-right"
          @click="current_item++"
        />
      </div>
    </div>
    <div v-else-if="messages && messages.length > 0">
      <p
        v-if="messages[current_item]"
        class="bg-neutral-100 mx-auto p-4 border rounded-sm w-full max-w-[600px] text-black text-base transition-all transition-duration-3000 select-none"
      >
        {{ messages[current_item] }}
      </p>
      <div class="flex justify-center gap-8 mt-4">
        <UButton
          :disabled="current_item <= 1"
          color="neutral"
          variant="subtle"
          size="xl"
          icon="i-lucide-move-left"
          aria-label="Last"
          :class="{ 'opacity-60': current_item <= 1 }"
          @click="current_item--"
        />
        <UButton
          :disabled="current_item >= messages.length - 1"
          :class="{ 'opacity-60': current_item >= messages.length - 1 }"
          color="neutral"
          variant="subtle"
          size="xl"
          aria-label="Next"
          icon="i-lucide-move-right"
          @click="current_item++"
        />
      </div>
    </div>
    <div v-else>
      <p>No content provided</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
// import type { Button } from '#ui/types'

interface Email {
  subject: string
  body: string
}

const current_item = ref(0)

defineProps({
  emails: {
    type: Array as PropType<Email[]>,
    required: false,
    default: undefined,
  },
  messages: {
    type: Array as PropType<string[]>,
    required: false,
    default: undefined,
  },
})
</script>
